import { render, staticRenderFns } from "./myCerificateFace.vue?vue&type=template&id=081987fe&scoped=true&"
import script from "./myCerificateFace.vue?vue&type=script&lang=js&"
export * from "./myCerificateFace.vue?vue&type=script&lang=js&"
import style0 from "./myCerificateFace.vue?vue&type=style&index=0&id=081987fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081987fe",
  null
  
)

export default component.exports